import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ipad-app-dev',
  templateUrl: './ipad-app-dev.component.html',
  styleUrls: ['./ipad-app-dev.component.css']
})
export class IpadAppDevComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/ipad-app-dev/ipad-app-dev.component.ts